import React, { Component } from "react";
import { GET, POST, tokens, loading, profile, company, alert, t } from "../components/CustomComponent.js";
import Language from "../components/Language.js";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
import { clearStorageKeepLang } from "../utils/backendMessage";

export default class Portal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyName: company?.name ||"-",
      user_profile: profile || null
    };
  }

  async componentDidMount() {
    const {user_profile} = this.state;
    loading(false);
    // console.log("company:",company)
    if(!user_profile){
      clearStorageKeepLang();
      window.location.href = "/";
    }
    if(user_profile && !company){
      await this.GetCompanies();
    }

    await this.GetProfile();
  }
 GetProfile = async () => {
    const result = await GET("admin/users/profile", null, false);
    if (result?.status) {
      localStorage.setItem("cm-profile", JSON.stringify(result.data));
      this.setState({user_profile: result.data});
    }
  };
  GetCompanies = async () => {
    const result = await GET("console"); 
  
    if (result?.status && Array.isArray(result.data)) {
      // ทำการ Map ข้อมูลจาก API ให้ตรงกับโครงสร้างที่ UI ต้องการ
      const mappedCompanies = result.data.map((item) => ({
        id: item.uid,               // Map uid เป็น id
        name: item.company_name,    // Map company_name เป็น name
        code: item.company_code,    // Map company_code เป็น code
        type: item.description,     // ใช้ description เป็น type
        // คงค่าเริ่มต้นสำหรับ UI ไว้
        iconColor: "#cfe2ff",
        textColor: "#084298",
        icon: "\uf1ad",
      }));

      localStorage.setItem("cm-company", JSON.stringify(mappedCompanies[0]));
    } else {
      console.error("Failed to fetch companies or data format error:", result);
    }
  };
  Logout = async () => {
    if (
      await alert(
        "",
        "warning",
        t("confirm"),
        t("logout_ask"),
        t("logout"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await POST("auth/logout");
      if (result?.status) {
        clearStorageKeepLang();
        window.location.href = "/";
      }
      loading(false);
    }
  };

  /**
   * นิยามพอร์ทัลทั้งหมด + สิทธิ์การเข้าถึงของ user ปัจจุบัน
   *
   * แสดงครบทุกใบเสมอ ใบที่เข้าไม่ได้จะจางลงและกดแล้วแจ้งเตือน
   * (เดิมซ่อนทิ้งไปเลย ทำให้ผู้ใช้ไม่รู้ว่ามีพอร์ทัลอื่นอยู่)
   */
  getPortals = (user_profile) => {
    const perms = user_profile?.role?.permission || [];
    // บัญชีระดับแพลตฟอร์ม/บริษัท ข้ามการตรวจสิทธิ์ระดับหน้า (ตรงกับ PermissionRoute)
    const bypass = ["super_user", "admin-company"].includes(user_profile?.user_type);

    // เข้าได้ต้องผ่านทั้ง 2 ด่าน: พอร์ทัลเปิดให้ user_type นี้ไหม (เช่นช่างเข้าได้เฉพาะพอร์ทัลแอดมิน)
    // และ role มี permission ของเมนูในพอร์ทัลนั้นอย่างน้อยหนึ่งเมนูไหม
    const byMenu = (portal, menu, fallback) => ({
      canAccess: bypass || (global.canAccessPortal(user_profile?.user_type, portal) && global.hasModuleAccess(menu, perms)),
      link: global.getFirstAccessibleLink(menu, perms) || fallback,
      reason: t("portal_no_permission"),
    });

    return [
      {
        key: "admin",
        icon: "\uf505",
        iconClass: "bg-primary text-light",
        linkClass: "text-primary",
        title: t("admin_portal"),
        desc: t("admin_desc"),
        ...byMenu("admin", global.menu_admin, "/ad/dashboard"),
      },
      {
        key: "customer",
        icon: "\uf1ad",
        iconClass: "bg-success text-light",
        linkClass: "text-success",
        title: t("customer_portal"),
        desc: t("customer_desc"),
        ...byMenu("customer", global.menu_customer, "/cs/dashboard"),
      },
      {
        key: "mobile",
        icon: "\uf3ce",
        iconClass: "bg-warning text-light",
        linkClass: "text-warning",
        title: t("mobile_portal"),
        desc: t("mobile_desc"),
        // พอร์ทัลมือถือคุมด้วยประเภทผู้ใช้ ไม่ใช่ permission (ไม่มีเมนูประกาศไว้ใน global.js)
        // super_user / admin-company เข้าได้ทุกพอร์ทัลเหมือนใบอื่น - ต้องใช้ bypass ด้วย
        // ไม่งั้นการ์ดใบนี้จะขึ้นล็อกทั้งที่ PermissionRoute ปล่อยผ่านอยู่แล้ว
        canAccess: bypass || user_profile?.user_type === "technician",
        link: "/mb/mobile",
        reason: t("portal_technician_only"),
      },
      {
        key: "warehouse",
        icon: "\uf494",
        // .bg-purple ใน style.css ใช้ !important (var(--bs-indigo)) ซึ่งชนะ inline style
        // ของเดิมจึงเป็นสีอินดิโก้เข้มเสมอ ส่วน backgroundColor: "#e2d3f5" ที่เคยใส่ไว้
        // เป็นโค้ดตายมาตลอด - ไม่ต้องใส่กลับ ไม่งั้นจะเข้าใจผิดว่าสีมาจากตรงนั้น
        iconClass: "bg-purple text-light",
        linkStyle: { color: "#8e44ad" },
        title: t("warehouse_portal"),
        desc: t("warehouse_desc"),
        ...byMenu("warehouse", global.menu_warehouse, "/wh/dashboard"),
      },
    ];
  };

  handlePortalClick = (portal) => {
    if (portal.canAccess) {
      window.location.href = portal.link;
      return;
    }
    alert("", "warning", t("no_permission"), portal.reason);
  };

  renderPortalCard = (portal) => {
    const locked = !portal.canAccess;

    return (
      <div className="col-12 col-md-6 col-xl-3" key={portal.key}>
        <div
          className={`card h-100 border-0 rounded-4 shadow-lg p-4 text-center cursor-pointer ${locked ? "" : "transition-hover"}`}
          style={locked ? { opacity: 0.55 } : undefined}
          onClick={() => this.handlePortalClick(portal)}
        >
          <div className="position-relative mx-auto mb-3" style={{ width: "80px", height: "80px" }}>
            <div
              className={`${locked ? "bg-secondary text-light" : portal.iconClass} rounded-4 w-100 h-100 d-flex align-items-center justify-content-center`}
              style={locked ? undefined : portal.iconStyle}
            >
              <span className="icon text-24">{portal.icon}</span>
            </div>
            {/* กุญแจมุมขวาบน บอกว่าใบนี้เข้าไม่ได้ */}
            {locked && (
              <div
                className="position-absolute top-0 end-0 translate-middle-y bg-white text-secondary border rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{ width: "26px", height: "26px" }}
              >
                <span className="icon text-12">{"\uf023"}</span>
              </div>
            )}
          </div>
          <h5 className="fw-bold text-dark">{portal.title}</h5>
          <p className="text-muted small mb-4">{portal.desc}</p>
          <div className="mt-auto">
            {locked ? (
              <button className="btn btn-link text-secondary text-decoration-none fw-bold w-100">
                <span className="icon me-1">{"\uf023"}</span> {t("no_permission")}
              </button>
            ) : (
              <button className={`btn btn-link text-decoration-none fw-bold w-100 ${portal.linkClass || ""}`} style={portal.linkStyle}>
                {t("enter")} <span className="icon ms-1">{"\uf061"}</span>
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { companyName, user_profile } = this.state;

    return (
        <div
            className="min-vh-100 d-flex flex-column text-white font-sans"
            style={{
                background: "linear-gradient(180deg, #1461bd 0%, #2985f2 100%)",
            }}
        >
            {/* Top Bar - Company Selector */}
            <div className="w-100 d-flex justify-content-between align-items-center px-4 py-2" style={{ backgroundColor: "rgba(0,0,0,0.1)" }}>
                <div className="d-flex align-items-center" style={{ fontSize: "0.85rem" }}>
                    <div className="me-2 rounded bg-white-light p-1 px-2 d-flex align-items-center justify-content-center">
                        <span className="icon">{"\uf1ad"}</span>
                    </div>
                    <div>
                        <div className="text-white-50" style={{ fontSize: "0.75rem" }}>
                            {t("current_company")}
                        </div>
                        <div className="fw-bold">{companyName}</div>
                    </div>
                </div>
                <div className="d-flex align-items-center">
                    <button
                        className="btn btn-sm text-white border-0 shadow-none"
                        onClick={() => {
                            window.location.href = "/console";
                        }}
                    >
                        <span className="icon me-2">{"\uf362"}</span> {t("change_company")}
                    </button>
                    <div className="hpx-40 mx-3" style={{ width: 1, backgroundColor: "var(--bs-gray-2)" }} />
                    <div className="d-flex align-items-center text-start user-badge px-2 py-1 rounded-lg">
                        <span className="user-avatar me-2 wpx-32 hpx-32 d-flex align-items-center justify-content-center" style={{ fontSize: "0.75rem" }}>
                            {user_profile?.full_name?.slice(0, 2).toUpperCase() || "US"}
                        </span>
                        <div className="pe-2">
                            <div className="text-14 fw-semibold text-dark">{user_profile?.full_name || "Username"}</div>
                            <div className="text-12 text-secondary" style={{ marginTop: -2 }}>
                                {user_profile?.role?.name || user_profile?.user_type?.replaceAll("_", " ") || "User"}
                            </div>
                        </div>
                        <button className="btn btn-sm border-0 p-2 text-dark" style={{ opacity: 0.7 }} onClick={() => this.Logout()} title="Logout">
                            <span className="icon">{"\uf08b"}</span>
                        </button>
                    </div>
                </div>
            </div>

            {/* Main Header */}
            <div className="container-fluid px-4 py-3 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <div className="bg-white rounded p-1 me-3 d-flex align-items-center justify-content-center" style={{ width: "45px", height: "45px" }}>
                        <img src={LOGO} alt="logo" className="img-fluid" style={{ maxHeight: "100%" }} />
                    </div>
                    <div>
                        <h4 className="mb-0 fw-bold">CMMS</h4>
                        <small className="d-none d-md-block">Computerized Maintenance Management System</small>
                    </div>
                </div>
                <Language />
            </div>

            {/* Welcome Section */}
            <div className="container text-center mt-4 mb-5">
                <h1 className="display-6 fw-bold mb-3">{t("welcome_title")}</h1>
                <p className="lead mb-4">{t("welcome_sub")}</p>
                <div className="d-inline-flex align-items-center bg-white-light rounded-pill px-4 py-2 border border-white">
                    <span className="icon me-2">{"\uf1ad"}</span> {companyName}
                </div>
            </div>

            {/* Portals Cards Grid */}
            <div className="container mb-5">
                <div className="row g-4 justify-content-center">
                    {this.getPortals(user_profile).map((portal) => this.renderPortalCard(portal))}
                </div>
            </div>

            {/* Bottom Feature Cards */}
            <div className="container mt-auto mb-4">
                <div className="row g-3">
                    <div className="col-12 col-md-4">
                        <div className="bg-white-light rounded-4 p-4 text-center border border-white h-100">
                            <div className="bg-white text-primary rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "40px", height: "40px" }}>
                                <span className="icon">{"\uf017"}</span>
                            </div>
                            <h6 className="fw-bold">{t("realtime")}</h6>
                            <small className="opacity-75">{t("realtime_desc")}</small>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="bg-white-light rounded-4 p-4 text-center border border-white h-100">
                            <div className="bg-white text-success rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "40px", height: "40px" }}>
                                <span className="icon">{"\uf201"}</span>
                            </div>
                            <h6 className="fw-bold">{t("analysis")}</h6>
                            <small className="opacity-75">{t("analysis_desc")}</small>
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="bg-white-light rounded-4 p-4 text-center border border-white h-100">
                            <div className="bg-white text-warning rounded-circle d-inline-flex align-items-center justify-content-center mb-3" style={{ width: "40px", height: "40px" }}>
                                <span className="icon">{"\uf3cd"}</span>
                            </div>
                            <h6 className="fw-bold">{t("mobile_support")}</h6>
                            <small className="opacity-75">{t("mobile_support_desc")}</small>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className="text-center py-4 mt-auto">
                <small className="opacity-80">
                    CMMS Version {global.version} - Multi-Company Edition
                    <br />
                    Computerized Maintenance Management System
                </small>
            </div>
        </div>
    );
  }
}